import { render, staticRenderFns } from "./IconEditProfile.vue?vue&type=template&id=3171dc2f"
import script from "./IconEditProfile.vue?vue&type=script&lang=js"
export * from "./IconEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports